import { trigger, animate, style, transition, state, query, animateChild, group } from '@angular/animations';
import { Block } from '@angular/compiler';

var testMode: boolean = false;
var animationTime: number = 1000;

if(testMode) {
  animationTime *= 10;
}

// Routable animations
// export const fadeInOutAnimation =
//   trigger('routeAnimation', [
//     transition('* <=> *', [
//       style({ opacity: 0 }),
//       animate(animationTime + 'ms ease-in-out', style({ opacity: 1 }))
//     ]),
//   ]);

export const fadeInOutAnimation =
  trigger('routeAnimation', [
    transition('* <=> *', [
      style({ position: 'relative' }),
      query(':enter, :leave', [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%'
        })
      ], { optional: true }),
      query(':enter', [
        style({ opacity: '0' })
      ], { optional: true }),
      query(':leave', animateChild(), { optional: true }),
      group([
        query(':leave', [
          animate(300, style({ opacity: 0 }))
        ], { optional: true }),
        query(':enter', [
          animate("300ms 300ms", style({ opacity: 1 }))
        ], { optional: true }),
        query('@*', animateChild(), { optional: true })
      ]),
    ])
  ]);

export const visibleContentAnimation =
  trigger('loadedFadeAnimation', [
    state('visible', style({
      opacity: 1
    })),
    state('hidden', style({
      opacity: 0
    })),
    state('void', style({
      opacity: 0
    })),
    transition('void <=> visible', [
      animate(animationTime + 'ms ease-in-out')
    ]),
  ]);


  export const heightContentAnimation =
  trigger('loadedHeightAnimation', [
    state('visible', style({
      opacity: 1,
      overflow: 'revert'
    })),
    state('hidden', style({
      opacity: 0,
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      marginTop: 0,
      marginBottom: 0,
      overflow: 'hidden'
    })),
    state('void', style({
      opacity: 0,
      height: 0,
      paddingTop: 0,
      paddingBottom: 0,
      marginTop: 0,
      marginBottom: 0,
      overflow: 'hidden'
    })),
    transition('void <=> visible', [
      animate((animationTime * .75) + 'ms ease-in-out')
    ])
  ]);
